// ** Next imports
import Image from "next/image";

// ** File imports
import Layout, { SEOHead } from "../../layouts/default";
import { CONTACT_INFO } from "../../helpers/DATA";

// ** Image imports
import careerImg from "../../../public/images/career-image.jpg";

interface PropsEl {
  children: React.ReactNode;
}

const Pcol = (props: PropsEl) => {
  return <p className="col-grey1">{props.children}</p>;
};

const Hcol = (props: PropsEl) => {
  return <h4 className="col-black">{props.children}</h4>;
};

const Careers = () => (
  <Layout>
    <SEOHead title="Carbon Neutral" />

    <section className="bg-silver1 pad-top-40 pad-bot-40">
      <div className="container">
        <div className="sec-head">
          <h1 className="no-margin text-center">
            <b>Careers</b>
          </h1>
        </div>
      </div>
    </section>

    <section className="pad-top-60 pad-bot-60">
      <div className="container">
        <div className="row">
          <div className="col-md-6 col-lg-6 col-sm-6 col-12">
            <div className="block-element m-t-20">
              <div className="custom-image2">
                <Image
                  src={careerImg}
                  className="img-fluid"
                  placeholder="blur"
                  alt="Career image"
                />
              </div>
            </div>
          </div>

          <div className="col-md-6 col-lg-6 col-sm-6 col-12">
            <div className="faq-textual">
              <Hcol>Working at EIN:</Hcol>

              <Pcol>
                We are proponents of balance and believe that work can be both
                fun and productive. Many of our positions are remote positions,
                allowing you to work from home or your favorite coffee shop.
              </Pcol>

              <Hcol>Open Positions:</Hcol>

              <Pcol>No open positions at this time.</Pcol>
              <Pcol>
                We’re always growing so feel free to email your resume or career
                inquiry to us anytime at{" "}
                <a href={`mailto:${CONTACT_INFO.email}`}>
                  {CONTACT_INFO.email}
                </a>
              </Pcol>
            </div>
          </div>
        </div>
      </div>
    </section>
  </Layout>
);

export default Careers;
